<template>
  <div class="el-card  pd20">
    <!-- add---新增 -->
    <div class="box">
      <!--  -->
      <div class="search">
        <div class="search-gropu">
          活动名称：
          <el-input class="search-child" v-model="posters_name" placeholder="请输入活动名称"></el-input>
          <el-button type="primary" @click="pullData" size="medium">查询</el-button>
          <el-button type="primary" @click="$router.push('/main/calendar_posters_form?related_type='+related_type)" size="medium">添加海报</el-button>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="el-card  pd20 content">
      <el-table :data="list" border style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="name" label="活动名称"> </el-table-column>
        <el-table-column label="海报模板">
          <template slot-scope="scope">
            <img :src="scope.row.image_url" alt="" class="image_url" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="updateHandle(scope.row)" circle></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeHandle(scope.$index, scope.row)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  poster_list,
  poster_remove
} from "@/api/calendar";
export default {
  data() {
      return {
        pages: {},
        list: [],
        obj: {},
        dialogVisible: false,
        activity: '',
        activityId: '',
        posters_name: '',
        related_type: ''
      }
    },
    methods: {
      updateHandle(row) {
        this.$router.push({
          path: '/main/calendar_posters_form',
          query: ({
            related_id: row.related_id,
            related_type: this.related_type,
            poster_id: row.id
          })
        })
      },
      poster_remove(row) {
        poster_remove({
          related_id: row.related_id,
          related_type: this.related_type,
          poster_id: row.id
        }).then((data) => {
          this.pullData();
        }).catch((err) => {
          this.$hideLoading();
        });
      },
      // 清退等级
      removeHandle(index, row) {
        this.$confirm('确定要删除吗？', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.poster_remove(row);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        });
      },
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      pullData() {
        this.$showLoading();
        this.related_type = this.$route.query.related_type;
        this.obj = {
          related_type: this.related_type, //关联类型（1=讲座活动，2=生涯活动）
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        if (this.posters_name != '') {
          this.obj['name'] = this.posters_name;
        }
        poster_list(this.obj).then((data) => {
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.headimgurl {
  width: 100px;
  height: 100px;
}

.box {
  margin-bottom: 20px;
}

.content {
  padding: 20px;
}

.userinfo {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
  span {
    width: 44px;
    display: block;
  }
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}

.search-child {
  margin-left: 20px;
  width: 150px;
  margin-right: 40px;
}

.buy-time {
  margin-left: 20px;
  width: 220px;
}
.image_url {
  width: 200px;
}
</style>
<style lang="scss">
.buy-time input {
  background-color: transparent !important;
  width: 60% !important;
}

.el-dialog {
  background-color: #fff !important;
}

.new-style .el-dialog .el-dialog__title {
  color: #333 !important;
}
</style>
